var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-home-intro"},[_c('div',{staticClass:"c-home-intro__inner"},[_c('home-intro-stars'),_c('enter',{on:{"clicked":_vm.playAnimationOnLeave}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }